import { Dropdown } from "react-bootstrap";
import { RouterPaths } from "../../../../app/appConstants";
import { ProfileButtonDropdownItemStyled } from "./styled/ProfileButtonStyled";
import BinIcon from "../../../../components/icon/Icon";
import React, { Fragment, useCallback } from 'react';
import { useGTMEvent } from "../../../GoogleTagManager/googleTagManagerHooks";
import _ from "lodash";
import appHistory from "../../../../app/appHistory";
import { MODALS_NAME } from "../../../Modals/modalsConstants";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import type { IOpenModalPayload } from "../../../../app/types/appActions.t";

type IItemsType = {
    name: string,
    type: 'divider',
} | {
    name: string,
    type: 'component',
    title: string
} | {
    icon: string,
    modal: typeof MODALS_NAME.PERSONAL | typeof MODALS_NAME.INTRO,
    name: string,
    type: 'modal',
    title: string,

} | {
    name: string,
    type: 'link',
    link: typeof RouterPaths.partner | typeof RouterPaths.respawn,
    icon: string,
    title: string
};

const items: IItemsType[] = [{
    icon: 'IcGear',
    modal: MODALS_NAME.PERSONAL,
    name: 'settings',
    title: 'menu.settings',
    type: 'modal',
}, {
    name: 'divider-1',
    type: 'divider',
}, {
    name: 'partner',
    type: 'link',
    link: RouterPaths.partner,
    icon: 'IcReferrals',
    title: 'menu.partner',
}, {
    name: 'respawn',
    type: 'link',
    link: RouterPaths.respawn,
    icon: 'IcRespawn',
    title: 'menu.new_life',
}, {
    name: 'support',
    type: 'component',
    title: 'menu.support',
}, {
    name: 'divider-2',
    type: 'divider',
}];

interface IDropdownMenuItemsProps {
    openModal: (type: IOpenModalPayload) => void,
    isShowMenuItem: (name?: string) => boolean,
    setRecentDone: (name?: string) => void;
    getMenuComponent: (name?: string) => React.MemoExoticComponent<({ children }: { children?: JSX.Element | undefined; }) => JSX.Element> | null,
    recents: {
        [name: string]: {}
    },

}

const DropdownMenuItems = (props: IDropdownMenuItemsProps) => {
    const {
        openModal,
        isShowMenuItem,
        getMenuComponent,
        recents,
        setRecentDone,
    } = props;

    const { getLangPath } = useLangContext();
    const { handleGTMClick } = useGTMEvent({ module: 'Header' });

    const onClickHandler = useCallback((e) => {
        const name = e.currentTarget.dataset.name;
        const item = _.find(items, { name });
        handleGTMClick({ button: name })
        if (!!item?.name && !!recents?.[item?.name]) {
            setRecentDone(item?.name);
        }
        if (item?.type === 'modal') {
            openModal(item.modal);
        }
        if (item?.type === 'link') {
            appHistory.push(item.link);
        }
    }, [handleGTMClick, recents, setRecentDone, openModal]);

    const getMenuItemRender = useCallback((item) => {
        if (!isShowMenuItem(item.name)) {
            return null;
        }
        if (item.type === 'divider') {
            return <Dropdown.Divider />
        }
        if (item.type === 'component') {
            const result = getMenuComponent(item.name);
            if (result === null)
                return null;
            const element = React.createElement(result, {
                children: <>{getLangPath(item.title)}</>
            });
            return (
                <Dropdown.Item>
                    {element}
                </Dropdown.Item>
            );
        }
        return (
            <Dropdown.Item data-name={item.name}
                onClick={onClickHandler}>
                <ProfileButtonDropdownItemStyled>
                    <BinIcon name={item.icon} style={{ minWidth: '1em' }} />
                    {getLangPath(item.title)}
                    {
                        !!recents?.[item.name] && <span className={'new'}>{getLangPath('menu.new')}</span>
                    }
                </ProfileButtonDropdownItemStyled>
            </Dropdown.Item>
        );
    }, [isShowMenuItem, onClickHandler, getLangPath, recents, getMenuComponent]);

    return (
        <>
            {items.map(item => <Fragment key={item.name}>{getMenuItemRender(item)}</Fragment>)}
        </>
    );
}

export default DropdownMenuItems;
